import styled from "@emotion/styled";
import { meta } from "../../styles/typography";
import TickSvg from "../../images/tick.svg";
import { transparentize } from "polished";
import { colours } from "../../styles/colours";
import { Field } from "formik";

export const inputHeightMobile = "48px";
export const inputHeightTablet = "56px";
export const inputHeight1200 = inputHeightTablet;
export const inputHeight1800 = inputHeightTablet;

export const inputMarginBottomMobile = "24px";
export const inputMarginBottomTablet = inputMarginBottomMobile;
export const inputMarginBottom1200 = "40px";
export const inputMarginBottom1800 = "40px";

export const InputContainer = styled.div`
	position: relative;
	flex: 1;
	width: 100%;
	margin-bottom: 0;
	@media screen and (min-width: 768px) {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: stretch;
		align-items: flex-end;
	}
	@media screen and (min-width: 1200px) {
		align-items: center;
	}
	@media screen and (min-width: 1800px) {
		align-items: flex-end;
	}
`;
export const FieldContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	align-items: flex-start;
	justify-content: space-evenly;
	width: 100%;
	margin-bottom: ${inputMarginBottomMobile};

	&.hidden {
		display: none;
	}

	@media screen and (min-width: 768px) {
		margin-bottom: ${inputMarginBottomTablet};

		&.field-container {
			&--email {
				width: 100%;
			}
		}
	}

	@media screen and (min-width: 1200px) {
		margin-bottom: ${inputMarginBottom1200};
		width: 100%;

		&.field-container {
			margin-bottom: ${inputMarginBottom1200};
			&--email {
				flex-grow: 1;
			}
		}
	}

	@media screen and (min-width: 1800px) {
		margin-top: ${inputMarginBottom1800};
		margin-bottom: ${inputMarginBottom1800};

		&.field-container {
		}
	}
`;

export const OptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	align-items: flex-start;
	width: 100%;
	text-align: left;
	gap: 8px;

	&:first-of-type {
		margin-bottom: 16px;
	}

	@media screen and (min-width: 1200px) {
		width: auto;
		margin-bottom: 0;
		justify-content: flex-start;
		flex-direction: row;
		align-items: center;
		width: 100%;
	}
`;
export const Input = styled(Field)`
	${meta};
	width: 100%;
	letter-spacing: 0.04em;
	appearance: none;
	background: white;
	border: none;
	padding: 0 15px;
	color: white;
	box-sizing: border-box;
	background: none;
	border: 1px solid white;
	height: ${inputHeightMobile};
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	border-radius: 0;

	&:focus {
		outline: none;
	}

	@media screen and (min-width: 768px) {
		padding: 0 23px;
		height: 100%;
		width: 100%;
		height: ${inputHeightTablet};
	}

	@media screen and (min-width: 1200px) {
		height: ${inputHeight1200};
	}

	@media screen and (min-width: 1800px) {
		height: ${inputHeight1800};
	}
`;
export const CheckboxInput = styled(Field)`
	display: none;

	&:checked + label {
		&::before {
			background: white;
		}
		&::after {
			opacity: 1;
		}
	}
`;
export const Label = styled.label`
	${meta};
	position: static;
	opacity: 1;
	line-height: 1.2;
	margin-bottom: 10px;
	display: inline-block;
	height: 17px;
`;
export const CheckboxLabel = styled.label`
	${meta};
	text-align: left;
	color: white;
	transition: opacity 0.2s;
	cursor: pointer;
	box-sizing: border-box;
	background: none;
	border-left: 0;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;

	span,
	p {
		padding-left: 16px;
	}

	&::before {
		content: "";
		background: none;
		border: 1px solid white;
		padding: 14px;
		display: inline-block;
		transition: background-color 0.2s ease;
	}

	&::after {
		content: "";
		display: inline-block;
		width: 10px;
		height: 10px;
		position: absolute;
		width: 28px;
		height: 28px;
		top: 1px;
		left: 1px;
		opacity: 0;
		transition: opacity 0.2s ease;
		background-image: url(${TickSvg});
		background-position: center center;
		background-repeat: no-repeat;
	}

	&:hover,
	&:focus {
		&::before {
			background: ${transparentize(0.2, "white")};
		}
	}

	&:focus {
		outline: none;
	}

	@media screen and (min-width: 768px) {
		padding-right: 20px;
		margin-right: 28px;

		&:first-of-type {
			margin-bottom: 16px;
		}
	}

	@media screen and (min-width: 1200px) {
		width: auto;
		margin-right: 42px;

		&:first-of-type {
			margin-bottom: 0;
		}
	}
`;
export const Submit = styled.button`
	${meta};
	border: none;
	padding: 0 47px;
	display: inline-block;
	font-weight: bold;
	background: none;
	height: ${inputHeightMobile};
	flex: 0;
	background: white;
	color: #001428;
	cursor: hand;
	cursor: pointer;
	transition: background-color 0.2s ease;
	margin: 0;
	width: 100%;

	&:hover {
		background: #a9c4e7;
	}

	&:focus {
		outline: none;
		background: #a9c4e7;
	}

	&:disabled {
		background: #d3d3d3;
		color: #666666;
		cursor: not-allowed;
	}

	span {
		position: relative;
		top: -1px;
	}

	@media screen and (min-width: 768px) {
		height: ${inputHeightTablet};
		flex-grow: 1;
		width: auto;
	}

	@media screen and (min-width: 1200px) {
		height: ${inputHeight1200};
		margin-right: 0;
		padding: 0 65px;
		flex-grow: 0;
	}

	@media screen and (min-width: 1800px) {
		height: ${inputHeight1800};
		width: auto;
		padding: 0 65px;
	}
`;
export const Terms = styled.div`
	${meta};
	color: ${transparentize(0.6, "white")};
	margin-top: ${inputMarginBottomMobile};
	width: 100%;

	@media screen and (min-width: 768px) {
		margin-top: ${inputMarginBottomTablet};
	}

	@media screen and (min-width: 1200px) {
		margin-top: ${inputMarginBottom1200};
	}

	@media screen and (min-width: 1800px) {
		margin-top: ${inputMarginBottom1800};
	}
	a {
		text-decoration: underline;
		transition: color 0.2s ease;
		&:visited {
			color: ${transparentize(0.6, "white")};
		}

		&:hover {
			color: ${colours.highlight};
		}
	}
`;
export const ErrorTextContainer = styled.div`
	margin-bottom: ${inputMarginBottomMobile};

	@media screen and (min-width: 768px) {
		margin-bottom: ${inputMarginBottomTablet};
	}

	@media screen and (min-width: 1200px) {
		margin-bottom: ${inputMarginBottom1200};
	}

	@media screen and (min-width: 1800px) {
		margin-bottom: ${inputMarginBottom1800};
	}
`;
export const ErrorText = styled.div`
	${meta};
	font-weight: 500;
	margin-bottom: 16px;
	width: 100%;
`;
export const Loading = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	+ form {
		opacity: 0.5;
		pointer-events: none;
	}
`;
export const Spinner = styled.div`
	border-radius: 50%;
	animation: 1.2s linear 0s infinite running spin;

	svg {
		fill: white;
		stroke: white;
		width: 30px;
		height: 30px;
	}

	@keyframes spin {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	@media screen and (min-width: 1200px) {
		svg {
			width: 60px;
			height: 60px;
		}
	}
`;
